export enum AccommodationPageNavSections {
  Photos = 'nav-photos',
  Overview = 'nav-overview',
  Amenities = 'nav-amenities',
  Rooms = 'nav-rooms',
  RoomsFilters = 'nav-roomsFilters',
  Reviews = 'nav-reviews',
  ReviewsSummary = 'nav-reviewsSummary',
  HotelLocation = 'nav-hotelLocation',
  Policies = 'nav-policies',
  PriceTrend = 'nav-priceTrend',
  FAQs = 'nav-faqs'
}
